import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import LoadingContent from "../../component/loading/LoadingContent";
import styled from "styled-components";
import Map from "../../component/map/Index";
import TableListStation from "./TableListStation";

import Service from "../../service/Map";
import Actions from "../../redux/actions";

const Section = styled.section`
  height: 100%;

  & > .container {
    height: 100%;

    & > .row {
      margin-top: 10px;
    }

    .map-container {
        height: 100%;
        max-height: 630px;
    }
  }
`;

export default function Index(props) {
  const [data, setData] = useState([]);
  const [mapData, setMapData] = useState([]);

  const [content, setContent] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(Actions.master.setPath("/map"));

    const init = async () => {
      let data = await Service.search();
      if (data) {
        let response = [];
        data.map((item) => {
          if (
            !response.find(
              (responseItem) => responseItem.station_name == item.station_name
            )
          ) {
            response.push({
              province_name: item.province_name,
              station_id: item.station_id,
              station_name: item.station_name,
              gps_lat: item.gps_lat,
              gps_long: item.gps_long,
              sensors: [],
            });
          }

          let responseItem = response.find(
            (responseItem) => responseItem.station_name == item.station_name
          );
          let sensor = {
            sensor_id: item.sensor_id,
            data_id: item.data_id,
            name: item.sensor_disp_name,
            type_name: item.sensor_type_disp_name,
            parameter_disp_name: item.parameter_disp_name,
            connection_status: item.connection_status,
            disp_connection: item.disp_connection,
            data_datetime: item.data_datetime,
            proc_data: item.proc_data,
          };
          responseItem.sensors.push(sensor);
        });
        setData(data);
        setMapData(response);
      }
      setContent(true);
    };

    init();
    const interval = setInterval(() => {
      init();
    }, 1000 * 60);
    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);

  return (
    <Section
      className={"section-map" + (props.className ? props.className : "")}
    >
      <div className="container">
        {!content ? (
          <LoadingContent />
        ) : (
          <>
            <div className="map-container">
              <Map data={mapData} />
            </div>
            <div className="row">
              <TableListStation data={data} />
            </div>
          </>
        )}
      </div>
    </Section>
  );
}
